import { AppIcon } from './AppIcon'
import { dashboardApps } from './DashboardApps'
import { useUnreadCount } from '@/features/ordrelogg'

export function AppGrid() {
  const { data: unreadCount = 0 } = useUnreadCount()

  return (
    <div className="grid grid-cols-2 gap-4">
      {dashboardApps.map((app) => (
        <AppIcon
          key={app.title}
          {...app}
          badge={app.to === '/ordrelogg' ? unreadCount : undefined}
        />
      ))}
    </div>
  )
}
